import React from "react";
import { Provider } from "react-redux";
import { store } from "./app-state/reducer";
import { AppRoutes, TotemRoutes } from "./routes";
import "./App.css";
import { ApplicationType, ThisPaths } from "./shared/Constants";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken, getUser } from "./shared/utils/LocalSessionHandler";
import { Actions } from "./app-state/actions";
import useIdleTimeout from "./shared/utils/useIdleTimeout";
import { SessionService } from "./services";
import { useHistory } from "react-router-dom";
import { env } from './env'

const isPwa = env.REACT_APP_APPLICATION_TYPE === ApplicationType.PWA;

const App: React.FC = () => {
    const history = useHistory();
    let handleIdle = () => {};
    
    if (!isPwa) {
        handleIdle = () => {
            if(getUser())
            {// verificar si logueado y desloguear
                SessionService.LogOut();
                store.dispatch(Actions.RESET_STATE());
                console.log('desloguear idle');
                history.replace(ThisPaths.LOGIN);
            }   
            // reniciar timer
            idleTimer.reset();
        }
    }

    const { idleTimer } = useIdleTimeout({ onIdle: handleIdle, idleTime: +env.REACT_APP_LOGOUT_SECONDS });
    

    if (getToken()) {
        store.dispatch(Actions.SET_SESSION(getUser()));
    }

    return (
        <Provider store={store}>
            <React.StrictMode>
                {isPwa ? <AppRoutes /> : <TotemRoutes />}
                {/* <ToastContainer autoClose={3000} /> */}
                <ToastContainer autoClose={+env.REACT_APP_CLOSE_TOAST_MILLISECONDS} />
                {/* {isPwa ? <ToastContainer autoClose={3000} />: <ToastContainer autoClose={1000} />} */}
            </React.StrictMode>
        </Provider>
    );
};

export default App;
